import React from 'react';

import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type AppTitleProps = {
  /** アイコン */
  icon: React.ReactNode;
  /** タイトル */
  title: string;
  /** テーマカラー */
  color?: string;
};

/**
 * ツールバーのアプリタイトル共通コンポーネント
 * アイコン + タイトル + ステージバッジのスタイリッシュなヘッダー
 */
const AppTitle: React.FC<AppTitleProps> = ({ icon, title, color = '#1565c0' }) => {
  return (
    <Stack direction="row" alignItems="center" spacing={1.5} sx={{ alignSelf: 'center' }}>
      {/* アイコン（グラデーション背景） */}
      <Box
        sx={{
          width: 28,
          height: 28,
          borderRadius: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: `linear-gradient(135deg, ${color} 0%, ${color}dd 100%)`,
          color: '#fff',
          flexShrink: 0,
        }}
      >
        {React.cloneElement(icon as React.ReactElement<{ sx?: object }>, {
          sx: { fontSize: 16 },
        })}
      </Box>

      {/* タイトル */}
      <Typography
        variant="body1"
        sx={{
          fontWeight: 700,
          letterSpacing: '-0.01em',
          color: 'text.primary',
          lineHeight: 1,
        }}
      >
        {title}
      </Typography>

      {/* ステージバッジ */}
      <Chip
        label="BETA"
        size="small"
        variant="outlined"
        sx={{
          height: 18,
          fontSize: '0.6rem',
          fontWeight: 700,
          letterSpacing: '0.05em',
          borderRadius: 0.75,
          borderColor: 'warning.main',
          color: 'warning.main',
          '& .MuiChip-label': { px: 0.5 },
        }}
      />
    </Stack>
  );
};

export default AppTitle;
